import { axiosInstance } from '@/utils/axiosInstance';

export const CLUB_PRICE_IN_CENTS = 3990;

export const CLUB_PRODUCT = {
  id: 0,
  nameId: 'clube-beneficios',
  title: 'Clube de Benefícios',
  totalPrice: 'R$ 39,90',
  purchaseLink: '',
  generateTokenInfos: null,
};

export type TClubCard = {
  name: string;
  cvv: string;
  number: string;
  validDate: string;
  numberInstallments: number;
  display: string;
  brand: string;
};

export type TPurchaseClubWithCardParams = {
  card: TClubCard;
  autoRenew: boolean;
  userInfo: any;
};

export type TGenerateClubPixParams = {
  userInfo: any;
};

export type TClubPixResult = {
  /** Código copia-e-cola do Pix (brcode). */
  pixCode: string;
  /** Link da cobrança no checkout, caso precise abrir a fatura. */
  paymentLink: string;
  raw: any;
};

export async function purchaseClubWithCard({
  card,
  autoRenew,
  userInfo,
}: TPurchaseClubWithCardParams) {
  const requestOptions = {
    method: 'POST',
    url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/club_benefits`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      creditCardData: {
        ...card,
        renew: autoRenew,
        numberInstallments: 1,
      },
      userInfo,
    },
  };

  const { data } = await axiosInstance(requestOptions);

  return data;
}

export async function generateClubPix({
  userInfo,
}: TGenerateClubPixParams): Promise<TClubPixResult> {
  const requestOptions = {
    method: 'POST',
    url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/club_benefits_pix`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      userInfo,
    },
  };

  const { data } = await axiosInstance(requestOptions);

  // O checkout devolve os dados da cobrança dentro de `payment`, e o código
  // copia-e-cola do Pix vem em `brcode`.
  const payment = data?.payment ?? data;

  return {
    pixCode: payment?.brcode ?? '',
    paymentLink: payment?.link ?? '',
    raw: data,
  };
}
